
import { useState } from "react";
import { Button, Grid, TextField } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query";
import { useModalesStore, useNotificacionesStore } from "../../../../store";
import { startAprobarTraslado } from "../../../../services";

import Swal from "sweetalert2";





export const FormAprobarTraslados = () => {


    const queryClient = useQueryClient();
    const { activeNotificacion } = useNotificacionesStore();
    const { changeEstadoModalUno } = useModalesStore(); 

    const [formProducto, setFormProducto] = useState({ observacion: '' });
    const [cargando, setCargando] = useState(false);
    const { observacion } = formProducto;
    const  handleChangeInput = ({ target }) => {
        setFormProducto({ ...formProducto, [target.name]: target.value});
    }




    const handleAprobarTraslados = async(e) => {
        e.preventDefault();
        if([observacion].includes('') ){
            return Swal.fire('Error', 'Formulario incorrecto por favor llene todos los campos', 'error');
        }
        await Swal.fire({
            title: `Ingresar Producto`,
            text: `¿Esta seguro de ingresar este producto?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si Ingresar`
        }).then( async( _ ) => {
            setCargando(true);
            const resp = await startAprobarTraslado({...formProducto, ...activeNotificacion });
            if(resp){
                setFormProducto({observacion: ''}); 
                changeEstadoModalUno(false)
                queryClient.invalidateQueries({queryKey: ['notificacion-xbodega']});
            }
            setCargando(false);
        });
    }





    return (

        <form onSubmit={ handleAprobarTraslados } >
            <Grid container spacing={ 2 }>
                <Grid item xs={12}>
                    <TextField required
                        size='small'
                        label='Observación'
                        type='number'
                        placeholder='Observación'
                        fullWidth
                        name='observacion'
                        value={ observacion }
                        onChange={ handleChangeInput }
                        multiline
                        minRows={3}
                    />
                </Grid>

            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={ 12 } sm={ 8 } >
                    <Button variant='contained' fullWidth type='submit' disabled={cargando}>
                        {`${activeNotificacion?.estado} Traslado`}
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}
